<template>
  <b-card header-class="p-0" no-body>
    <template v-slot:header>
      <div
        class="d-flex align-items-center justify-content-between w-100 px-4 py-3"
        style="cursor: pointer"
        v-b-toggle="'package-units-collapse'"
      >
        <span>{{ packages.length }} {{ (packages[0] && packages[0].unitType) || 'Unit' }}(s) Shipped</span>
        <div class="d-flex align-items-center">
          <i :class="collapsed ? 'fa fa-chevron-down' : 'fa fa-chevron-up'" class="text-muted"></i>
        </div>
      </div>
    </template>

    <b-collapse id="package-units-collapse" @show="collapsed = false" @hide="collapsed = true">
      <div class="card-body">
        <div v-if="!packages || packages.length === 0" class="text-center py-4 text-muted">
          <i class="fa fa-archive fa-2x mb-2"></i>
          <p class="mb-0 small">No packages recorded yet.</p>
        </div>

        <div v-else>
          <div
            v-for="(pkg, pkgIndex) in packages"
            :key="pkg.id || pkgIndex"
            class="border rounded mb-2"
          >
            <!-- Package header -->
            <div class="d-flex align-items-center justify-content-between" style="background-color: #737b87; padding: 12px 13px;">
              <div class="d-flex align-items-center flex-nowrap" style="overflow: hidden; min-width: 0">
                <span class="text-white-50 small mr-2 flex-shrink-0">#{{ pkgIndex + 1 }}</span>
                <span :class="unitTypeBadgeClass(pkg.unitType)" class="mr-3 flex-shrink-0" style="font-size: 0.8rem; padding: 0.25em 0.55em">
                  {{ pkg.unitType }}
                </span>
                <span class="text-white-50 small mr-1 flex-shrink-0">Package Code:</span>
                <span class="text-white font-weight-bold mr-3 flex-shrink-0">{{ pkg.packageCode || '(no code)' }}</span>
                <span v-if="pkg.trackingNumber" class="text-white-50 small mr-1 flex-shrink-0">Tracking:</span>
                <span v-if="pkg.trackingNumber" class="text-white flex-shrink-0">{{ pkg.trackingNumber }}</span>
              </div>
              <span class="text-white-50 small ml-3 flex-shrink-0">
                contains {{ totalQty(pkg) }} unit(s)
              </span>
            </div>

            <!-- Line items table -->
            <table class="table table-sm mb-0">
              <thead style="background-color: #e8ecf0;">
                <tr>
                  <th class="text-muted" style="font-weight: 600; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em">SKU</th>
                  <th class="text-muted text-center" style="font-weight: 600; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em">Qty</th>
                  <th class="text-muted" style="font-weight: 600; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em">Lot #</th>
                  <th v-if="pkg.unitType !== 'Pallet'" class="text-muted" style="font-weight: 600; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em">LPN</th>
                  <th class="text-muted" style="font-weight: 600; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em">Expires</th>
                  <th v-if="pkg.unitType !== 'Pallet'" class="text-muted" style="font-weight: 600; font-size: 0.78rem; text-transform: uppercase; letter-spacing: 0.04em">Location</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="!pkg.lineItems || pkg.lineItems.length === 0">
                  <td :colspan="pkg.unitType === 'Pallet' ? 4 : 6" class="text-center text-muted py-2 small">No line items</td>
                </tr>
                <tr v-for="(li, liIndex) in pkg.lineItems" :key="li.id || liIndex">
                  <td>
                    <strong>{{ li.sku }}</strong>
                    <div v-if="getItemName(li.sku)" class="small text-muted">{{ getItemName(li.sku) }}</div>
                  </td>
                  <td class="text-center">{{ li.quantity }}</td>
                  <td>{{ li.lotNumber || '-' }}</td>
                  <td v-if="pkg.unitType !== 'Pallet'">{{ li.lpn || '-' }}</td>
                  <td>
                    <span v-if="li.expiresDate">{{ li.expiresDate }}</span>
                    <span v-else class="text-muted">-</span>
                  </td>
                  <td v-if="pkg.unitType !== 'Pallet'">{{ li.warehouseLocationCode || '-' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </b-collapse>
  </b-card>
</template>

<script>
export default {
  name: 'PackageUnitsList',

  props: {
    packages: {
      type: Array,
      default: function() { return []; }
    },
    items: {
      type: Array,
      default: function() { return []; }
    }
  },

  data: function() {
    return {
      collapsed: true
    };
  },

  methods: {
    totalQty: function(pkg) {
      return (pkg.lineItems || []).reduce(function(s, li) { return s + (li.quantity || 0); }, 0);
    },

    unitTypeBadgeClass: function(unitType) {
      if (unitType === 'Pallet') return 'badge badge-primary';
      if (unitType === 'Case') return 'badge badge-success';
      return 'badge badge-secondary';
    },

    getItemName: function(sku) {
      var match = (this.items || []).find(function(i) { return i.item === sku; });
      return match ? match.description : null;
    }
  }
};
</script>
